import(/* webpackMode: "eager" */ "/vercel/path0/apps/game/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@1.6.1_next@15.0.7_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4__react@19.2.4/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.7_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/script.js");
